import R from 'ramda'

export const isExist = R.allPass([
  R.complement(R.isNil),
  R.complement(R.isEmpty)
])

export default isExist



// WEBPACK FOOTER //
// ./src/util/index.js